import { colors } from '../../Colors/colors'

export const advancedFiltersTheme = {
   light: {
      filters: {
         bgColor: 'bg-base-white',
         searchIconColor: colors['gray-500'],
         filterHeaderBgColor: 'bg-gray-50',
         outlineDotsVerticalColor: colors['gray-500'],
         chevronDownIconColor: colors['gray-500'],
         filterTitleColor: 'text-gray-800',
         filterBottomBorderColor: 'text-gray-300',
         filterCardBgColor: 'bg-base-white',
         filterCardBorderColor: 'border-gray-300',
         plusIconColor: colors['primary-600'],
         plusIconDisabledColor: colors['gray-400'],
         disabledPlusIconColor: colors['gray-300'],
         horizontalLineColor: 'border-gray-300',
         pickerTextColor: 'text-gray-900',
         conditionsTitleColor: 'text-gray-800',
         xCloseIconColor: colors['gray-500'],
         checkIconColor: colors['primary-600'],
         menu: {
            actionHoverBg: 'hover:bg-gray-50'
         },
         toggle: {
            borderColor: 'border-gray-100',
            backgroundColor: 'bg-gray-50',
            color: 'text-gray-500',
            selected: {
               bgColor: 'bg-base-white',
               color: 'text-gray-700'
            },
            horizontalLineColor: 'border-gray-300'
         },
         conditionOperator: {
            color: 'text-primary-700',
            bgColor: 'bg-primary-50',
            horizontalLineColor: 'border-gray-300'
         },
         leadStageField: {
            customOptionHoverBgColor: 'hover:bg-gray-50',
            focusBgColor: 'bg-gray-50',
            selectedBgColor: 'bg-gray-50',
            customOptionTextColor: 'text-gray-900',
            customBadgeTextColor: 'text-gray-700',
            checkIconColor: colors['primary-600'],
            badgeBorderColor: 'border-gray-300',
            badgeCloseIconColor: colors['gray-400']
         },
         quickFilters: {
            addFilterButtonIconFill: colors['gray-600'],
            userOptionLabelColor: 'text-gray-700'
         },
         arithmeticOperator: {
            operatorTextColor: 'text-gray-900',
            background: 'bg-base-white',
            disabledBackground: 'bg-gray-50',
            borderColor: 'border-gray-300 ',
            plusIconFillColor: colors['gray-500'],
            minusIconFillColor: colors['gray-500'],
            playUpIconFillColor: colors['gray-400'],
            playDownIconFillColor: colors['gray-300']
         },
         filterSetCount: {
            userIconColor: colors['primary-600'],
            valueColor: 'text-gray-900',

            borderColor: 'border-gray-300',
            labelColor: 'text-gray-500',
            userIconSecondaryColor: colors['gray-600']
         },
         actions: {
            actionItemHoverColor: 'hover:bg-gray-50',
            dividerColor: 'border-gray-200',
            actionItemTextColor: 'text-gray-900',
            deleteTextColor: 'text-error-600'
         }
      }
   },
   dark: {}
}
